import styled from '@emotion/styled';
import { useRef } from 'react';

import UpIcon from './UpIcon';

function Fab() {
    const ref = useRef<HTMLButtonElement>(null);
    const scrollToTop = () => {
        const container = ref.current?.parentElement?.parentElement;
        container?.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <Base ref={ref} onClick={scrollToTop}>
            <UpIcon/>
        </Base>
    );
}

const Base = styled.button`
    align-items: center;
    background-color: var(--color-gray1);
    border-radius: 8px;
    bottom: calc(20px + var(--safe-area-bottom));
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
    display: flex;
    height: 40px;
    justify-content: center;
    position: fixed;
    right: 20px;
    width: 40px;
`;

export default Fab;
